var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsCircleSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.032,
    height: 24.73,
    viewBox: "0 0 26.032 24.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.032,
    y1: 0.032,
    x2: 0.97,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5961c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a41ac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MS_teams",
    "data-name": "MS teams",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M39.81,17.111v5.206a3.9,3.9,0,0,1-7.81,0V15.81h6.508A1.3,1.3,0,0,1,39.81,17.111Zm-3.9-3.9a2.6,2.6,0,1,0-2.6-2.6A2.6,2.6,0,0,0,35.9,13.206Z",
    transform: "translate(-13.778 -6.047)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M28.016,16.064v7.159a6.508,6.508,0,0,1-6.941,6.494A6.656,6.656,0,0,1,15,23V14.762H26.714A1.3,1.3,0,0,1,28.016,16.064ZM21.508,12.81a3.9,3.9,0,1,0-3.9-3.9A3.9,3.9,0,0,0,21.508,12.81Z",
    transform: "translate(-7.841 -5)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 4.068,
    cy: 3.661,
    rx: 4.068,
    ry: 3.661,
    transform: "translate(9.762 0.163)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M22.159,28.668V20H15v8.237a6.882,6.882,0,0,0,.614,2.826h4.148A2.4,2.4,0,0,0,22.159,28.668Z",
    transform: "translate(-7.841 -10.238)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M15,20v8.237a6.873,6.873,0,0,0,.361,2.176h4.333a2.031,2.031,0,0,0,2.031-2.031V20Z",
    transform: "translate(-7.841 -10.238)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M21.291,20H15v8.237a6.848,6.848,0,0,0,.178,1.525h4.446A1.666,1.666,0,0,0,21.291,28.1V20Z",
    transform: "translate(-7.841 -10.238)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M15.714,27.016H5.3a1.3,1.3,0,0,1-1.3-1.3V15.3A1.3,1.3,0,0,1,5.3,14H15.714a1.3,1.3,0,0,1,1.3,1.3V25.714A1.3,1.3,0,0,1,15.714,27.016Z",
    transform: "translate(-4 -8.143)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M15.227,19H9.932v1.119h1.983v5.389h1.329V20.118h1.983Z",
    transform: "translate(-6.072 -9.888)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsCircleSmallIcon);
export default __webpack_public_path__ + "static/media/teams-circle-small-icon.6586cbf7f01e132cab86dbca978ea637.svg";
export { ForwardRef as ReactComponent };